import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment.prod';


@Injectable({
  providedIn: 'root'
})
export class GetService {

  private Content_Type = 'application/json';
  url_auth = environment.api_get_authentication;

  constructor(private httpClient: HttpClient) { }


  /**
* get
*/
  public get(body) {
    let headers = new HttpHeaders()
    .set("Content-Type", this.Content_Type);    
    return this.httpClient.post(
      this.url_auth + "get",
      body
    );
  }
}
